var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.77 15.4459C19.2997 15.4459 22.1604 12.5476 22.1604 8.9715C22.1604 5.39539 19.2997 2.49707 15.77 2.49707C12.2404 2.49707 9.37967 5.39539 9.37967 8.9715C9.37967 12.5476 12.2404 15.4459 15.77 15.4459ZM20.2433 17.0645H19.4095C18.3012 17.5805 17.0681 17.8738 15.77 17.8738C14.472 17.8738 13.2438 17.5805 12.1305 17.0645H11.2968C7.59237 17.0645 4.58691 20.1095 4.58691 23.8627V25.9669C4.58691 27.3073 5.66029 28.3948 6.98329 28.3948H24.5567C25.8797 28.3948 26.9531 27.3073 26.9531 25.9669V23.8627C26.9531 20.1095 23.9477 17.0645 20.2433 17.0645Z",
    fill: "#032A4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashUsers);
export default __webpack_public_path__ + "static/media/dash_users.2036868d4a9abf048f9a7cb3d2e723e1.svg";
export { ForwardRef as ReactComponent };